import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import { SearchUtils } from "../PA.UIM.Core/SearchUtils";
import { PASearch } from "../PA.Core/PASearch";
import { PAEnvironment } from "../PA.Core/PAEnvironment";


const vUI_CBO_Search_Fields: { [id: string]: ISearchProviderField } = {
    WB_CBO_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: { columnName: 'Wb CBO Id', columnResourceName: 'colId', alignment: HorizAlignment.Left },
        domainOptions: {}
    },
    CBO_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'ID', columnResourceName: 'colCBOId', alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 50 }
    },
    CBO_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Name', columnResourceName: 'colCBOName', alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 50 }
    },
    CREATED_BY: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Created By', columnResourceName: 'colCreator', alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 50 }
    },
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreatedDt',
            alignment: HorizAlignment.Center,
            dateFormat: 'MM/dd/yyyy'
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Last Modified',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: 'MM/dd/yyyy'
        },
        domainOptions: {}
    },
    MODEL: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Published Model',
            columnResourceName: 'colModel',
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 250 }
    }
};

const SimulationInputSearchProviderBasic: ISearchProvider = {

    keyFields: {
        id: 'WB_CBO_ID',
        id_ui: 'CBO_ID',
        name: 'CBO_NAME'

    },

    searchProviderFields: vUI_CBO_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {
            const findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_ConstraintBasedOptimizer_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err) => {
                    error(err)
                });
        })
    }
};

const CBOSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5SourceId: "CBOSearchProfileByName" },

    profileFilter: [
        { profileFilterName: 'Id', searchProviderFieldId: 'CBO_ID', renderOptions: {} },
        { profileFilterName: 'Name', searchProviderFieldId: 'CBO_NAME', renderOptions: {} }
    ], //ISearchFields
    profileDisplayFields: [
        'CBO_ID', 'CBO_NAME', "CREATED_BY", "CREATED_DTTS", "MODIFIED_DTTS", "MODEL"
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: SimulationInputSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const ConstraintBasedOptimizerSearch: ISearch = {
    searchName: "Find Promotion Optimizer",
    renderOptions: { ui5ResourceId: "ConstraintBasedOptimizerSearch" },
    searchProfileIdDefault: "default",
    searchProfiles: [CBOSearchProfileByName]
};
PAEnvironment.registerBusinessObjectSearch("ConstraintBasedOptimizerBO", "ConstraintBasedOptimizer", ConstraintBasedOptimizerSearch, " Promotion Optimizer Search")

export { ConstraintBasedOptimizerSearch }

